// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__T0rgk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__IWCsu","obliqueLine":"membershipbadge_obliqueLine__213uy"};